<template>
  <div class="container">
    <div>
      <el-form
        inline
        size="mini"
        label-width="50px"
        class="table-search-part"
        @submit.native.prevent="handleQuery()"
        style="display: flex;justify-content: space-between;"
      >
        <div>
          <el-form-item label="Operator">
            <el-input v-model="queryData.operateUser" placeholder="Operator"></el-input>
          </el-form-item>
          <el-form-item label="Operation Time" label-width="110px">
            <el-date-picker
              v-model="operationTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="pickerOptions"
              @change="orderDate"
              type="datetimerange"
              range-separator="-"
              start-placeholder="Start Time"
              end-placeholder="End Time"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="Module" class="module-input">
            <el-select
              v-model="queryData.module"
              placeholder="Module"
              clearable
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in moduleList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-button class="search-btn" @click="handleQuery()">Search</el-button>
          <el-button class="clear-btn" @click="handleClearQuery()">Clear</el-button>
        </div>
        <div>
          <el-button type="primary" @click="handleExport()">Download</el-button>
        </div>
      </el-form>
    </div>
    <div class="syslog-table">
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        v-loading="loading"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column label="Operation Time" min-width="150">
          <template v-slot="{row}">
            <div v-if="row.createTime">{{ formatUtc(row.createTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Operation Type" prop="opType" min-width="150px"></el-table-column>
        <el-table-column label="Module" prop="module" min-width="180px"></el-table-column>
        <!-- <el-table-column type="expand">
          <template slot-scope="props">
            <p class="over-content">{{ formatContent(props.row.content) }}</p>
          </template>
        </el-table-column>-->
        <el-table-column
          label="Content"
          prop="content"
          min-width="628px"
          :show-overflow-tooltip="true"
        >
          <template v-slot="{row}">
            <div>{{ deleteContentId(row) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="Detail"
          prop="afterData"
          min-width="120px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="Operator"
          prop="operateUser"
          min-width="180px"
          :show-overflow-tooltip="true"
        ></el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.pageNum"
        :page-size="queryData.pageSize"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Empty from "@/components/empty/index";
import { getSystemLogList, downSystemLogList } from "@/api/systemLog";
export default {
  name: "LogList",
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      queryData: {
        pageNum: 1,
        pageSize: 50,
        operateUser: "",
        module: "",
        startTime: "",
        endTime: ""
      },
      moduleList: [
        {
          id: 8,
          label: "Channel Detail Modify"
        },
        {
          id: 17,
          label: "Channel Tournament Block"
        },
        {
          id: 4,
          label: "User Limit"
        },
        {
          id: 7,
          label: "User Level"
        },
        {
          id: 10,
          label: "User Odds Level"
        },
        {
          id: 12,
          label: "User OddsDrop Template"
        },
        {
          id: 5,
          label: "User Status"
        },
        {
          id: 13,
          label: "User Self-Risk"
        },
        {
          id: 14,
          label: "User Suspend Betting Factor"
        },
        {
          id: 15,
          label: "User Remark"
        },
        {
          id: 1,
          label: "System User Limit"
        },
        {
          id: 6,
          label: "System User Level"
        },
        {
          id: 11,
          label: "System OddsDrop Template"
        },
        {
          id: 9,
          label: "System Channel Template"
        },
        {
          id: 16,
          label: "System Warning Template"
        },
        {
          id: 18,
          label: "System Order Risk Tag"
        },
        {
          id: 19,
          label: "Order Risk Tag"
        },
        {
          id: 20,
          label: "User Delay Order"
        },
        {
          id: 21,
          label: "User Delay Settle"
        },
        {
          id: 22,
          label: "User Margin Odds Level"
        },
        {
          id: 23,
          label: "User Promotions Status"
        },
        {
          id: 24,
          label: "System Promotions Template"
        }
      ],
      operationTime: [],
      tableHeight: window.innerHeight,
      pickerOptions: {
        disabledDate(time) {
          let _now =
              new Date(new Date().toLocaleDateString()).getTime() +
              24 * 60 * 60 * 1000 -
              1,
            month = 30 * 24 * 60 * 60 * 1000,
            monthDays = _now - month;
          return time.getTime() > _now || time.getTime() < monthDays;
        }
      }
    };
  },
  methods: {
    deleteContentId(item){
      if(item.module == "Order Risk Tag"){
        let idxStart = item.content.indexOf(' (');
        if(idxStart > -1){
          return item.content.substr(0,idxStart)
        }
      }
      return item.content
    },
    orderDate([startTime, endTime]) {
      this.queryData.startTime = startTime;
      this.queryData.endTime = endTime;
    },
    async getList() {
      this.loading = true;
      try {
        const res = await getSystemLogList(this.queryData);
        const data = res.data || {};
        this.list = data.records || [];
        this.total = data.total;
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    // 清空
    handleClear() {
      this.queryData = {
        ...this.queryData,
        pageNum: 1,
        pageSize: 50,
        operateUser: "",
        module: "",
        startTime: "",
        endTime: ""
      };
      this.operationTime = [];
    },
    // 搜索
    handleQuery() {
      this.queryData.pageNum = 1;
      this.getList();
    },
    // 清除搜索
    handleClearQuery() {
      this.handleClear();
      //this.getList();
    },
    // 分页
    changePage(e) {
      this.queryData.pageNum = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.pageSize = e;
      this.queryData.pageNum = 1;
      this.getList();
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    handleExport() {
      let timeZoneOffset = this.$moment().utcOffset() / 60;
      let param = { ...this.queryData, timeZone: timeZoneOffset };
      downSystemLogList(param, "export.xlsx");
    },
    // 去除空格
    formatContent(val) {
      return val.replace(/\s+/g, "");
    }
  },
  components: {
    Empty
  },
  mounted() {
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  }
};
</script>

<style lang="scss" scoped>
.module-input {
  margin: 0 20px 0 0 !important;
  /deep/.el-input {
    width: 200px !important;
  }
}
</style>
